// import store from '@/store'
import { ConVendorName } from '@/config'
import moment from 'moment'
moment.locale('zh-cn')

// 时间过滤器
// 2018-08-28
function timeToL(time) {
  return moment(time).format('YYYY-MM-DD')
}
function timeTol(time) {
  return moment(time).format('YYYY-MM-DD').substring(2)
}
function timeTol2(time) {
  return moment(time).format('YYYY/MM/DD')
}

// 2018年8月28日
function timeToLL(time) {
  return moment(time).format('LL')
}

// 2018年8月28日上午9点19分
function timeToLLL(time) {
  if (!/1970-01-01|0001-01-01/.test(time)) {
    // return moment(time).format('YYYY-MM-DD HH:mm:ss').slice(2)
    return moment(time).format('YYYY-MM-DD HH:mm:ss')
  } else {
    return '暂无'
  }
}

// 时间戳转换
function timeToHHMMSS(time) {
  let timeNew = moment(time).format('YYYY-MM-DD HH:mm:ss')
  if (!(timeNew.includes('1970-01-20') || timeNew.includes('1970-01-21'))) {
    return timeNew
  } else {
    return '--'
  }
}

function timeToLLLL(time) {
  return moment(time).format('HH:mm:ss')
}

// 计算订单总和
function toOrderCount(item) {
  let count = 0
  item.orderDetail.forEach(item => {
    count += item.count
  })
  return count
}

// 订单状态转中文
function toBusinessWords(status) {
  let arr = ['订单收入', '盈亏预估', '有效订单量']
  return arr[status]
}

// 730 -> 7:30 时间转换
function timeToXX(str) {
  // if (str === 0) return '无'
  // if (str.toString().length < 4) {
  //   str = '0' + str
  // } else {
  //   str = '' + str
  // }
  // return str.substring(0, 2) + ':' + str.substring(2, str.length)
  str = str.toString()
  if (str.length < 2) str = '0' + str
  if (str.length < 3) str = '0' + str
  if (str.length < 4) str = '0' + str

  return str.slice(0, 2) + ':' + str.slice(2, 4)
}

// 门店状态转换 -1禁用 0休息 1营业中
function switchStatus(int) {
  switch (int) {
    case -1:
      return '休息'
    case 0:
      return '临时休息'
    case 1:
      return '营业'
    case -2:
      return '禁用'
    default:
      return '未知'
  }
}

// 坐标除以 10的6次方
function chu106(int) {
  return int / 1000000
}

// 转换图片地址取得适合大小的图片
function appendImgURL(url) {
  return url.split('?')[0] + '?imageView2/1/w/60/h/60'
}

// 商品价格 除以100 保留2位小数
function dealPrice(str) {
  let num = str / 100
  return num.toFixed(2)
}

// 过滤skus 库存状态
function dealSkuStatus(arr) {
  if (arr instanceof Array) {
    return arr.filter(item => item.status === 1).length ? '上架' : '下架'
  } else {
    return '无sku信息'
  }
}

// 过滤 JDSkuID
function dealJDSkuID(arr) {
  // return '1'
  if (arr instanceof Array) {
    let str = []
    arr.forEach(item => {
      str.push(item.jdID)
      // str += `<p>${item.jdID}</p>`
    })
    return str // .join(', ')
  } else {
    return '无sku信息'
  }
}

// 截断手机号
function spliceTel(tel) {
  return `${tel.slice(0, 3)}-${tel.slice(3, 7)}-${tel.slice(7, 11)}`
}

// 订单状态
function switchOrderStatus(num) {
  switch (num) {
    case 5:
      return '新订单'
    case 10:
      return '待拣货'
    case 15:
      return '待配送'
    case 20:
      return '配送中'
    case 110:
      return '完成'
    case 105:
      return '妥投'
    case 115:
      return '已取消'
    case 120:
      return '订单失败'
    case 17:
      return '取货失败待审核'
    case 18:
      return '取货失败'
    case 22:
      return '投递失败'
    default:
      return `${num}(未知)`
  }
}

// 配送方式
function switchWaybill(num) {
  switch (num) {
    case -1:
      return '未安排'
    case 0:
      return '京东到家专送' // '达达专送'
    case 1:
      return '美团专送'
    case 2:
      return '饿了么专送'
    case 101:
      return '达达配送'
    case 102:
      return '美团配送'
    case 103:
      return '蜂鸟配送'
    default:
      return `${num}(未知)`
  }
}

// 平台商
function switchVendoID(num) {
  let vendorItem = ConVendorName.find(item => +num === +item.vendorID)
  if (vendorItem) {
    return vendorItem.nick
  } else {
    return `${num}(未知)`
  }
}

// 促销类型
function promotionType(num) {
  switch (num) {
    case 3:
      return '直降'
    case 4:
      return '秒杀'
    default:
      return `${num}(未知)`
  }
}
// 促销状态
function promotionStatus(num) {
  switch (num) {
    case 0:
      return '本地创建成功'
    case 1:
      return '远程创建失败'
    case 2:
      return '远程创建成功'
    case 3:
      return '已取消'
    case 4:
      return '已结束'
    default:
      return `${num}(未知)`
  }
}

// skuName状态
function filterSkuNameStatus(status) {
  switch (status) {
    case -1:
      return '删除'
    case 0:
      return '不可售'
    case 1:
      return '正常'
    default:
      return '未知'
  }
}

export const computedPrice = (item) => {
  if (item.unit === '份') {
    let skuNamePrice = Math.floor(item.temPrice * 100) // 一斤的价格
    let specQuality = item.specQuality // 质量
    let specUnit = item.specUnit.toLowerCase() // 单位
    if (specUnit === 'kg' || specUnit === 'l') {
      specQuality = specQuality * 1000
    }
    let temPrice = Math.round(skuNamePrice * specQuality / 500)
    return temPrice / 100
  } else {
    return item.temPrice
  }
}
export const isNumber = (val) => {

  var regPos = /^\d+(\.\d+)?$/; //非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true;
  } else {
    return false;
  }

}
// vendorName
// export function vendorName (vendorID) {
//   return store.getters.serverInfo.vendorName ? store.getters.serverInfo.vendorName[vendorID] : ''
// }

export default { timeToL, timeTol, timeTol2, timeToLL, timeToLLL, timeToHHMMSS, timeToLLLL, toOrderCount, toBusinessWords, timeToXX, switchStatus, chu106, appendImgURL, dealPrice, dealSkuStatus, dealJDSkuID, spliceTel, switchOrderStatus, switchWaybill, switchVendoID, promotionType, promotionStatus, filterSkuNameStatus }



// WEBPACK FOOTER //
// ./src/filters/index.js